import { Link } from "react-router-dom";
import { HandHeart, Users, HeartHandshake, ArrowRight } from "lucide-react";
import { PROFILE_TYPES } from "@/lib/profileTypes";
import Seo from "@/components/Seo";

const steps = [
  { n: "1", title: "Join", icon: HandHeart, body: "Create a free account. Tell us who you are and what you're looking for — we tailor your experience accordingly." },
  { n: "2", title: "Connect", icon: Users, body: "Join prayer groups, share testimonies, attend gatherings, find churches and ministries near you." },
  { n: "3", title: "Serve", icon: HeartHandshake, body: "Volunteer, give, mentor, list your business, support a brother or sister. Faith works through love." },
];

export default function HowItWorks() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      <Seo
        title="How it works · Jesus Just Us"
        description="Three simple steps: join, connect, serve. Discover how Jesus Just Us welcomes individuals, churches, ministries, nonprofits, and businesses into one Kingdom family."
        path="/how-it-works"
      />
      <div className="text-center">
        <div className="overline text-burgundy">How it works</div>
        <h1 className="font-serif text-5xl text-jjblue mt-3">Three simple steps</h1>
        <p className="mt-5 text-[var(--jj-text-secondary)] max-w-2xl mx-auto">
          You don't need to be religious or polished to belong here. You just need to come honestly.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mt-12">
        {steps.map((s) => (
          <div key={s.n} className="jj-card p-7" data-testid={`how-step-${s.n}`}>
            <div className="flex items-center gap-3">
              <span className="font-serif text-5xl text-gold leading-none">{s.n}</span>
              <s.icon className="h-7 w-7 text-burgundy" strokeWidth={1.4} />
            </div>
            <h3 className="font-serif text-2xl text-jjblue mt-5">{s.title}</h3>
            <p className="mt-3 text-[var(--jj-text-secondary)] text-[15px] leading-relaxed">{s.body}</p>
          </div>
        ))}
      </div>

      <div className="mt-16">
        <div className="overline text-burgundy">Who joins JJU?</div>
        <h2 className="font-serif text-3xl text-jjblue mt-2">A place for every member of the body</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mt-8">
          {PROFILE_TYPES.map((t) => (
            <div key={t.key} className="jj-card p-4 flex items-start gap-3" data-testid={`who-${t.key}`}>
              <div className="h-9 w-9 rounded-lg bg-cream-surface flex items-center justify-center shrink-0">
                <t.icon className="h-4 w-4 text-burgundy" strokeWidth={1.7} />
              </div>
              <div>
                <div className="font-medium text-jjblue text-sm">{t.label}</div>
                <div className="text-xs text-[var(--jj-muted)] mt-0.5">{t.blurb}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-14 text-center">
        <Link to="/register" className="btn-primary inline-flex items-center gap-2" data-testid="how-cta">
          Begin together <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
